import ValueSourceOptionsGroup from './ValueSourceOptionsGroup'
import * as ValueSourceType from '../../constant/ValueSourceType'
import * as OfferModelTemplate from '../../constant/OfferModelTemplate'
import * as SimpleOfferNameTemplate from '../../constant/SimpleOfferNameTemplate'
import * as ExternalValueSourceType from '../../constant/ExternalValueSourceType'

export const CUSTOM_INPUT_OPTION_MODE = {
    CUSTOM_FIRST: 'CUSTOM_FIRST',
    CUSTOM_LAST: 'CUSTOM_LAST',
    CUSTOM_ONLY: 'CUSTOM_ONLY',
}


class ValueSourceOptionsGroupStorage {
    /** @type {Array<ValueSourceField>} */
    product_source_fields
    /** @type {Array<ValueSourceField>} */
    product_id_source_fields
    /** @type {Array<ValueSourceField>} */
    feature_source_fields
    /** @type {Array<ValueSourceField>} */
    price_source_fields
    /** @type {Array<ExternalValuesSourceGroupMeta>} */
    external_values_source_groups

    currency_codes
    image_size_options

    /**
     * @param {Array<ValueSourceField>} product_source_fields
     * @param {Array<ValueSourceField>} product_id_source_fields
     * @param {Array<ValueSourceField>} feature_source_fields
     * @param {Array<ValueSourceField>} price_source_fields
     * @param {Array<ExternalValuesSourceGroupMeta>} external_values_source_groups
     * @param currency_codes
     * @param image_size_options
     */
    init(product_source_fields,
         product_id_source_fields,
         feature_source_fields,
         price_source_fields,
         external_values_source_groups,
         currency_codes,
         image_size_options
    ) {
        this.product_source_fields = product_source_fields
        this.product_id_source_fields = product_id_source_fields
        this.feature_source_fields = feature_source_fields
        this.price_source_fields = price_source_fields
        this.external_values_source_groups = external_values_source_groups
        this.currency_codes = currency_codes
        this.image_size_options = image_size_options
    }

    /**
     * @return {ValueSourceOptionsGroup}
     */
    getVendorModelTemplateOptionsGroup() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.MODEL_TEMPLATE
        group.group_label = 'Шаблон формирования'
        group.options = [{
            label: '[Название]',
            value: OfferModelTemplate.NAME,
        }, {
            label: '[Название] ([Артикул])',
            value: OfferModelTemplate.NAME_AND_SKU,
        }, {
            label: '[Артикул]',
            value: OfferModelTemplate.SKU,
        },]
        return group
    }

    /**
     * @return {ValueSourceOptionsGroup}
     */
    getSimpleNameTemplateOptionsGroup() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.NAME_TEMPLATE
        group.group_label = 'Шаблон формирования'
        group.options = [
            {
                label: '[Название]',
                value: SimpleOfferNameTemplate.NAME,
            }, {
                label: '[Название] ([Артикул])',
                value: SimpleOfferNameTemplate.NAME_AND_SKU,
            }, {
                label: '[Артикул]',
                value: SimpleOfferNameTemplate.SKU,
            },
        ]
        return group
    }

    getVatOptions() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.SPECIFIC
        group.group_label = ''
        group.options = [
            {
                label: 'Налоговая ставка',
                value: 'PRODUCT_VAT',
            }, {
                label: 'Нет налога',
                value: 'NO_VAT',
            }, {
                label: '0%',
                value: '0',
            },
            {
                label: '10%',
                value: '10',
            },
            {
                label: '20%',
                value: '20',
            },
        ]
        return group
    }

    getAdditionalTypeOptionGroup() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.SPECIFIC
        group.group_label = ''

        group.options = [
            {
                label: '%',
                value: 'PERCENT',
            }
        ]
        for (const currencyCode of this.currency_codes) {
            group.options.push({
                label: currencyCode,
                value: currencyCode
            })
        }

        return group
    }
    getUnitOptionGroup() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.SPECIFIC
        group.group_label = ''

        group.options = [
            {
                label: 'г.',
                value: 'g',
            },
            {
                label: 'кг.',
                value: 'kg',
            }
        ]

        return group
    }
    /**
     * @param {String|Undefined} label
     * @return {ValueSourceOptionsGroup}
     */
    getEmptyValueOptionsGroup(label = 'Пропустить') {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.IS_EMPTY
        group.group_label = label
        return group
    }

    /**
     * @return {ValueSourceOptionsGroup}
     */
    getDefaultValueOptionsGroup() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.IS_DEFAULT
        group.group_label = 'По умолчанию'
        return group
    }

    /**
     * @param custom_options
     * @param input_option_mode
     * @return {ValueSourceOptionsGroup}
     */
    getSpecificValueOptionsGroup(custom_options = [], input_option_mode = CUSTOM_INPUT_OPTION_MODE.CUSTOM_FIRST) {

        const group = new ValueSourceOptionsGroup()

        group.group_label = 'Фиксированное значение'
        group.group_source_type = ValueSourceType.SPECIFIC
        group.options = []

        const input_option = {
            label: 'Пользовательское значение',
            value: '',
        }

        if (Array.isArray(custom_options)) {
            for (const option of custom_options) {
                group.options.push({
                    label: option.label,
                    value: option.value,
                })
            }
        }

        if (input_option_mode === CUSTOM_INPUT_OPTION_MODE.CUSTOM_FIRST) {
            group.options.unshift(input_option)
        } else if (input_option_mode === CUSTOM_INPUT_OPTION_MODE.CUSTOM_LAST) {
            group.options.push(input_option)
        }
        return group
    }
    getSpecificValueOptionsGroupOnlyCustom(custom_options = []) {

        const group = new ValueSourceOptionsGroup()
        group.group_source_type = ValueSourceType.SPECIFIC
        group.options = []

        if (Array.isArray(custom_options)) {
            for (const option of custom_options) {
                group.options.push({
                    label: option.label,
                    value: option.value,
                })
            }
        }

        return group
    }
    /**
     * @param highlighted_value
     * @return {ValueSourceOptionsGroup}
     */
    getProductFieldValueOptionsGroup(highlighted_value = null) {
        const group = new ValueSourceOptionsGroup()

        group.group_label = 'Основное свойство товара'
        group.group_source_type = ValueSourceType.PRODUCT_FIELD
        group.options = this.product_source_fields.map(field => ({
            label: field.label,
            value: field.field,
        }))
        return group
    }

    /**
     * @param highlighted_value
     * @return {ValueSourceOptionsGroup}
     */
    getCountValueOptionsGroup(highlighted_value = null) {

        const group = new ValueSourceOptionsGroup()

        group.group_label = 'Основное свойство товара'
        group.group_source_type = ValueSourceType.PRODUCT_FIELD
        group.options = [{
            label: "Количество товара на складе",
            value: "count",
        }]


        return group
    }

    /**
     * @param highlighted_value
     * @return {ValueSourceOptionsGroup}
     */
    getProductWithIdsFieldValueOptionsGroup(highlighted_value = null) {
        const group = new ValueSourceOptionsGroup()

        group.group_label = 'Основное свойство товара'
        group.group_source_type = ValueSourceType.PRODUCT_FIELD

        const id_fields = this.product_id_source_fields.map(field => ({
            label: field.label,
            value: field.field,
        }))

        const main_fields = this.product_source_fields.map(field => ({
            label: field.label,
            value: field.field,
        }))

        group.options = [...id_fields, ...main_fields]
        return group
    }
    getUserFormatSku() {
        const group = new ValueSourceOptionsGroup()

        group.group_source_type = ValueSourceType.USER_FORMAT_SKU

        group.options = [{
            label: 'Форматированный артикул(поле Формат SKU)',
            value: ValueSourceType.USER_FORMAT_SKU
        }]
        return group
    }
    /**
     * @param highlighted_value
     * @return {ValueSourceOptionsGroup}
     */
    getProductPricesValueOptionsGroup(highlighted_value = null) {
        const group = new ValueSourceOptionsGroup()

        group.group_label = 'Цены'
        group.group_source_type = ValueSourceType.PRODUCT_PRICE
        group.options = this.price_source_fields.map(field => ({
            label: field.label,
            value: field.field,
        }))
        return group
    }

    /**
     * @param highlighted_value
     * @return {ValueSourceOptionsGroup}
     */
    getProductFeaturesValueOptionsGroup(highlighted_value = null) {
        const group = new ValueSourceOptionsGroup()

        group.group_label = 'Характеристика'
        group.group_source_type = ValueSourceType.PRODUCT_FEATURE
        group.options = this.feature_source_fields.map(field => ({
            label: field.label,
            value: field.field,
        }))
        return group
    }

    /**
     * @return {Array<ValueSourceOptionsGroup>}
     */
    getExternalValueOptionsGroups() {
        const groups = []

        for (const sources_group of this.external_values_source_groups) {
            const group = new ValueSourceOptionsGroup()

            if (sources_group.type === ExternalValueSourceType.PLUGIN) {
                group.group_label = `Плагин "${sources_group.name}"`
            } else if (sources_group.type === ExternalValueSourceType.APP) {
                group.group_label = `Приложение "${sources_group.name}"`
            } else {
                continue
            }

            group.group_source_type = ValueSourceType.EXTERNAL
            group.options = sources_group.source_metas.map(source_meta => ({
                label: source_meta.name,
                value: `${sources_group.type}|${sources_group.id}|${source_meta.value_id}`,
            }))

            groups.push(group)
        }

        return groups
    }

    getOfferTypeOptionsGroup() {
        const group = new ValueSourceOptionsGroup()
        group.group_source_type = ValueSourceType.SPECIFIC
        group.options = [
            {
                label: 'Упрощённый тип',
                value: 'SIMPLE'
            },
            {
                label: 'Произвольный тип',
                value: 'VENDOR'
            },
            {
                label: 'Комбинированный',
                value: 'COMBINED'
            }
        ]

        return group
    }

    getSwitchOptionsGroup() {
        const group = new ValueSourceOptionsGroup()
        group.group_source_type = ValueSourceType.SPECIFIC
        group.options = [
            {
                label: 'Есть',
                value: 'YES'
            },
            {
                label: 'Нет',
                value: 'NO'
            }
        ]

        return group
    }

    getImageSizesOptionsGroup() {
        const group = new ValueSourceOptionsGroup()
        group.group_source_type = ValueSourceType.SPECIFIC
        group.options = this.image_size_options

        return group
    }

    getDeliveryWeekdays() {
        const group = new ValueSourceOptionsGroup()
        group.group_label = 'Фиксированные значения(выберите несколько)'
        group.group_source_type = ValueSourceType.FIXED_COMMA_SEPARATED
        group.options = [
            {
                label: 'Понедельник(MONDAY)',
                value: 'MONDAY'
            },
            {
                label: 'Вторник(TUESDAY)',
                value: 'TUESDAY'
            },
            {
                label: 'Среда(WEDNESDAY)',
                value: 'WEDNESDAY'
            },
            {
                label: 'Четверг(THURSDAY)',
                value: 'THURSDAY'
            },
            {
                label: 'Пятница(FRIDAY)',
                value: 'FRIDAY'
            },
            {
                label: 'Суббота(SATURDAY)',
                value: 'SATURDAY'
            },
            {
                label: 'Воскресенье(SUNDAY)',
                value: 'SUNDAY'
            }
        ]
        return group
    }
}

const valueSourceOptionsGroupStorage = new ValueSourceOptionsGroupStorage()
export default valueSourceOptionsGroupStorage
